import { render, staticRenderFns } from "./QDatePicker.vue?vue&type=template&id=84e5529a&scoped=true&"
import script from "./QDatePicker.vue?vue&type=script&lang=js&"
export * from "./QDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e5529a",
  null
  
)

export default component.exports